export class OktaError extends Error {
	constructor(public errorCode: string, public errorMessage: string = '', public url?: string) {
		super(errorMessage);
		this.url = this.url || new URL(window.location.href).toString();

		Object.setPrototypeOf(this, OktaError.prototype);
	}
}
